/**
 * The crop editor settings every upload surface shares (ISSUE-1094).
 */

/** media-api keeps nothing larger: MEDIA_VARIANT_MAX_DIMENSIONS_PX.original in services/media-api/src/lib/imagePipeline.ts. */
export const CROP_OUTPUT_MAX_EDGE_PX = 1024;
/** POOL_BANNER_ASPECT_RATIO in services/media-api/src/lib/imagePipeline.ts, and PoolBannerField's aspect-[3/1] preview. */
export const POOL_BANNER_CROP_ASPECT = 3;
export const PHOTO_CROP_ASPECT = 1;
export const POOL_BANNER_CROP_TITLE = "Frame your banner";
export const PHOTO_CROP_TITLE = "Frame your photo";
